<template>
  <full-window>
    <FcLogo/>
  </full-window>
</template>

<script>
import FullWindow from '@/components/FullWindow'
import FcLogo from '@/components/FcLogo'

export default {
  components: {
    FullWindow,
    FcLogo
  },
  data () {
    return {
      title: 'Future Classic'
    }
  }
}
</script>
